import React from 'react';

interface Props {
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    // Limpar dados de autenticação
    localStorage.removeItem('user');
  }

  private handleReloadClick = () => {
    // Limpar dados de autenticação e recarregar
    localStorage.removeItem('user');
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
          <h1 className="text-2xl font-bold mb-4">Oops, algo deu errado.</h1>
          <p className="text-gray-600 mb-6 text-center">
            Por segurança, você foi desconectado. Por favor, faça login novamente.
          </p>
          <button
            className="px-4 py-2 bg-[#FF3366] text-white rounded hover:bg-[#E62E5C] transition-colors"
            onClick={this.handleReloadClick}
          >
            Voltar para o login
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;